import { Component, OnInit, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../_services/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from '../app.component';
import { ActivatedRoute, Router , Routes, RouterModule} from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  form: any = {
    newPassword: null,
    confirmPassword: null,
    token: null
  };

  submitted = false;

  errorMessage = '';

  constructor(private authService: AuthService, private http: HttpClient, private route: ActivatedRoute,  private routes: Router) { }


  ngOnInit(): void {

    console.log('params', this.route.snapshot.queryParamMap);
    
    this.route.queryParams
      .subscribe(params => {
        //console.log('params', this.route.snapshot.queryParamMap.get('token')); // { orderby: "price" }
        this.form.token = this.route.snapshot.queryParamMap.get('token');
        //console.log(this.form.token); // price
      }
    );


  }

  onSubmit(): void {
    const { newPassword, token } = this.form;

    this.authService.confirmReset(token, newPassword ).subscribe({
      next: data => {
        console.log("Data --> ", data);
        this.routes.navigate([ '/connexion']);
      },
      error: err => {
        this.errorMessage = err.error.message;
      }
    });
  }

}
